<template>
  <CDialog
    :title="$t('Change password')"
    :visible.sync="currentVisible"
    submittable
    :submit-label="$t('Submit')"
    :submit-loading="loading"
    closeable
    @submit="onChangePassword"
    @before-open="onBeforeOpen"
    @open="onOpen"
  >
    <form @submit="onChangePassword">
      <CInput
        ref="currentPassword"
        name="currentPassword"
        type="password"
        :label="$t('Current password')"
        v-model.trim="currentPassword"
        required
        :min-length="8"
        :max-length="32"
        :error-msg="errorMsg"
        :disabled="loading"
      />

      <CInput
        ref="newPassword"
        name="newPassword"
        type="password"
        :label="$t('New password')"
        v-model="newPassword"
        required
        :min-length="8"
        :max-length="32"
        :disabled="loading"
      />
    </form>
  </CDialog>
</template>

<script>
import Vue from 'vue';
import { mapActions } from 'vuex';
import { sleeper } from '@/lib/tools';

import CDialog from '@/components/uikit/CDialog';
import CInput from '@/components/uikit/CInput';

const messages = {
  en: {
    'Change password': 'Change password',
    Password: 'Password',
    'Current password': 'Current password',
    'New password': 'New password',
    Submit: 'Submit',
    'Please enter the correct password.': 'Please enter the correct password.',
  },
  ja: {
    'Change password': 'パスワードの変更',
    Password: 'パスワード',
    'Current password': '現在のパスワード',
    'New password': '新しいパスワード',
    Submit: '変更する',
    'Please enter the correct password.': '正しいパスワードを入力してください。',
  },
};

export default Vue.extend({
  name: 'MyAccountPasswordDialogChange',
  i18n: { messages },
  components: { CDialog, CInput },
  props: {
    value: {
      type: Boolean,
    },
  },
  data() {
    return {
      currentPassword: '',
      newPassword: '',
      errorMsg: '',
      loading: false,
    };
  },
  watch: {
    currentPassword(value) {
      this.currentPassword = value.replace(/\s+/g, '');
      this.errorMsg = '';
    },
    newPassword(value) {
      this.newPassword = value.replace(/\s+/g, '');
      this.errorMsg = '';
    },
  },
  computed: {
    currentVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    ...mapActions('password', ['patchPassword']),

    onBeforeOpen() {
      this.currentPassword = '';
      this.newPassword = '';
      this.errorMsg = '';
    },

    onOpen() {
      this.$refs['currentPassword'].focus();
    },

    async onChangePassword() {
      try {
        // Log
        this.$alpha.logger.addBreadcrumb('Click Change password button.');

        // Start Request
        this.loading = true;

        const params = {
          currentPassword: this.currentPassword,
          newPassword: this.newPassword,
        };

        await this.patchPassword(params);
        await sleeper(1000);

        // After Request
        await this.$alpha.notify.success('change', this.$t('Password'));
        this.currentVisible = false;
      } catch (e) {
        if (e === 'Wrong password') {
          this.errorMsg = this.$t('Please enter the correct password.');
        }

        if (e === 'Change password failed') {
          await this.$alpha.notify.error('change', this.$t('Password'));
        }
      } finally {
        this.loading = false;
      }
    },
  },
});
</script>
